<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="规格名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['specName']" placeholder="请输入规格名称"></a-input>
        </a-form-item>
        <a-form-item label="规格编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['specCode']" placeholder="请输入规格编码"></a-input>
        </a-form-item>
        <a-form-item label="规格值" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select mode="tags" v-decorator="['specValue']" placeholder="请输入规格值"
                    @change="handleChange"
          ></a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'



  export default {
    name: "ManufactureProductSpecsModal",
    components: {
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/manufacture/manufactureProductSpecs/add",
          edit: "/manufacture/manufactureProductSpecs/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        if(this.model.specValue){
          this.model.specValue = JSON.parse(this.model.specValue)
        }
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'specName','specCode','specValue'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.specValue = JSON.stringify(values.specValue)
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'specName','specCode','specValue'))
      },
      handleChange(value) {
        console.log(`selected ${value}`);
      }

    }
  }
</script>